/** PlanWire group (canonical `42dmnPbY`). A single read-only, on-demand lookup of
 *  the live planning status PlanWire holds for an application. Admin-gated — it
 *  rides the same staff bearer token as the rest of the console. The call costs a
 *  billed third-party request, so callers must trigger it on an explicit user
 *  action (never on mount, never polling). There is deliberately no write path:
 *  the response is informational, and the user updates the internal status by hand. */

import { api } from "./client";
import type { PlanWireStatusResponse } from "@/types";

/** GET /application-status?application_id — derive the council + reference from the
 *  application row server-side and pull PlanWire's record. `application_id` is the
 *  only param the frontend needs. Pass a signal to abort an in-flight lookup if the
 *  drawer/card unmounts. */
export function getApplicationStatus(
  applicationId: number,
  signal?: AbortSignal,
): Promise<PlanWireStatusResponse> {
  return api.get<PlanWireStatusResponse>("planwire", "application-status", {
    query: { application_id: applicationId },
    signal,
  });
}
